import React from 'react';
import { Progress } from 'antd';
import { CONTENT_HEIGHT } from '../../../constants';

const Summary: React.FC<{ fullScreen?: boolean, orgReport?: OrgReport, squre?: boolean }> = ({ fullScreen, squre, orgReport }) => {
    const clientHeight = fullScreen ? document.documentElement.clientHeight : CONTENT_HEIGHT;
    const size = squre ? 0.06 * clientHeight : 0.06 * clientHeight;
    const fontSize = size / 4;
    const datas = [
        {
            color: 'rgb(55, 185, 199)',
            title: '设备总数',
            value: orgReport?.totalDeviceCnt
        },
        {
            color: '#52c41a',
            title: '在线设备',
            value: orgReport?.totalOnline
        },
        {
            color: orgReport?.totalOffline === 0 ? '#52c41a' : 'rgb(226, 185, 31)',
            title: '离线设备',
            value: orgReport?.totalOffline
        },
        {
            color: orgReport?.totalAlarmCnt === 0 ? '#52c41a' : 'rgb(251, 71, 64)',
            title: '告警总数',
            value: orgReport?.totalAlarmCnt
        },
    ]
    return (
        <div style={
            squre ? {
                display: 'grid',
                gridTemplateColumns: '50% 50%',
                gridTemplateRows: '40% 40%',
                height: '100%',
            } :
                { display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'space-between' }}>
            {
                datas.map(i => {
                    return (
                        <div key={i.title} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            ...(
                                squre ? { paddingTop: '1em' } : {}
                            )
                        }}>
                            <Progress strokeColor={i.color} size={size} type="dashboard" percent={100}
                                format={() =>
                                (
                                    <div style={{ color: i.color, fontSize: '1.2em', fontWeight: 500 }}>{i.value}</div>
                                )} />
                            <div style={{
                                border: `1px solid ${i.color}`,
                                borderRadius: 4,
                                padding: '0 2px',
                                color: i.color, textAlign: 'center', fontSize
                            }}>{i.title}</div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default Summary;